<template>
    <div>
        <v-card-text>
            <i-beacon-table
                :search="search"
                :items="ibeacons"
                :options="pagination"
                @edit="openEditIBeaconPanel"
            />
        </v-card-text>

        <right-panel
            ref="editIBeaconPanel"
            :title="$t('ibeacon.editHeader')">
            <template v-slot:content="{ context }">
                <i-beacon-details-view
                    ref="ibeaconDetailView"
                    :ibeacon="context"/>
            </template>

            <template v-slot:bottom>
                <v-spacer/>
                <v-btn
                    width="120px"
                    color="primary"
                    @click="onEditIBeaconSave">
                    {{ $t('button.save') }}
                </v-btn>
            </template>
        </right-panel>
    </div>
</template>

<script>
import IBeaconTable from '@/components/tables/IBeaconTable'
import RightPanel from '@/components/panels/RightPanel'
import IBeaconDetailsView from '@/views/details/IBeaconDetailsView'

import { mapGetters } from 'vuex'

export default {
    name: 'IBeaconListView',

    components: {
        IBeaconDetailsView,
        IBeaconTable,
        RightPanel
    },

    props: {
        ibeacons: {
            type: Array,
            default: () => []
        },

        search: {
            type: String,
            default: ''
        },

        pagination: {
            type: Object,
            default: () => {}
        }
    },

    computed: {
        ...mapGetters({
            getIBeaconById: 'ibeacon/getIBeaconById'
        })
    },

    methods: {
        openEditIBeaconPanel (item) {
            const ibeacon = this.getIBeaconById(item.id)

            if (ibeacon) {
                this.$refs.editIBeaconPanel.open(ibeacon)
            }
        },

        closeEditIBeaconPanel () {
            this.$refs.editIBeaconPanel.close()
        },

        async onEditIBeaconSave () {
            await this.$refs.ibeaconDetailView.save()
            this.closeEditIBeaconPanel()
        }
    }
}
</script>

<style lang="scss" scoped></style>
